export default {"src":"/_next/static/media/request-call.408bf6ff.svg","height":58,"width":117,"blurWidth":0,"blurHeight":0};